import type { UseQueryOverrideOptions } from '../../../types'
import { useQuery, useXmppListener, useUserInfo, useNuxtApp, useQueryClient } from '#imports'

export interface SeamlessWalletAccountDetailsHostedWallets {
    wallets: any[]
    total_balance: string
    total_count: number
}

export interface SeamlessWalletAccountDetailsWallets {
    BONUS: string
    CASH: string
    CASH_WITH_BONUS_TERMS: string
}

export interface SeamlessWalletAccountDetailsResponse {
    balance: string
    game_wallet_type: 'HOSTED' | 'SEAMLESS'
    hosted_wallets: SeamlessWalletAccountDetailsHostedWallets
    status: string
    wagering_requirement: any
    wagering_requirements: any[]
    wallets: SeamlessWalletAccountDetailsWallets
    withdrawable_amount: string
}

export type UseSeamlessWalletAccountDetailsOptions = Omit<UseQueryOverrideOptions, 'enabled'>

export const useSeamlessWalletAccountDetails = (options: UseSeamlessWalletAccountDetailsOptions = {}) => {
    const { isLoggedIn } = useUserInfo()
    const nuxtApp = useNuxtApp()
    const queryClient = useQueryClient()

    if (!nuxtApp._seamlessWalletXmppRegistered) {
        nuxtApp._seamlessWalletXmppRegistered = true

        useXmppListener<{ balance: string }>({ kind: 'message', type: 'headline', xmlns: 'cego:UserBalanceUpdated' }, () => {
            queryClient.refetchQueries({ key: 'seamlessWallet:account_details' })
        })
    }

    return useQuery<SeamlessWalletAccountDetailsResponse | undefined>('/gateway/seamless-wallet/api/public/v1/account/details', {
        lazy: true,
        server: false,
        ...options,
        key: 'seamlessWallet:account_details',
        enabled: isLoggedIn.value,
        service: 'seamlessWallet',
    })
}
